import {
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  Typography,
} from "@mui/material";
import React, { FC, startTransition, useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { userState } from "../../../../../../states/userState";
import {
  backGroundColorCode,
  foreColor,
  foreColorCode,
  foreColorCodeDisabled,
  foreColorCodeLite,
  foreColorDisabled,
} from "../../../../../../commons/colors";

const ProductionDepartment = (props) => {
  const {
    departmentName,
    departmentId,
    productItems,
    setCheckedItems,
    checkedItems,
    checkedItemsForUi,
    setCheckedItemsForUi,
  } = props;
  const user = useRecoilValue(userState);
  const [parentChecked, setParentChecked] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [filteredCheckedItems, setFilteredCheckedItems] = useState([]);
  useEffect(() => {
    setFilteredCheckedItems(() => {
      const filteredItems = productItems.filter((item) =>
        checkedItemsForUi.includes(item.id)
      );
      return filteredItems.map((item) => item.id);
    });
  }, [checkedItemsForUi, productItems.length, checkedItems.length]);
  useEffect(() => {
    if (filteredCheckedItems.length === productItems.length) {
      setParentChecked(true);
      setIndeterminate(false);
    } else if (filteredCheckedItems.length === 0) {
      setParentChecked(false);
      setIndeterminate(false);
    } else {
      setParentChecked(false);
      setIndeterminate(true);
    }
  }, [filteredCheckedItems, productItems.length]);

  const handleChildChange = (id) => {
    // console.log("setCheckedItems", filteredCheckedItems);
    setCheckedItems((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleParentChange = () => {
    if (!parentChecked) {
      setParentChecked(true);
      setCheckedItemsForUi((prevState) => {
        // prevStateに存在しないitem.idだけを追加する
        const newItems = productItems
          .map((item) => item.id)
          .filter((id) => !prevState.includes(id));
        return [...prevState, ...newItems];
      });
      startTransition(() => {
        setCheckedItems((prevState) => {
          // prevStateに存在しないitem.idだけを追加する
          const newItems = productItems
            .map((item) => item.id)
            .filter((id) => !prevState.includes(id));
          return [...prevState, ...newItems];
        });
      });
    } else {
      setParentChecked(false);
      setCheckedItemsForUi((prevState) => {
        // console.log("setCheckedItems", filteredCheckedItems, prevState);
        return prevState.filter((item) => !filteredCheckedItems.includes(item));
      });
      startTransition(() => {
        setCheckedItems((prevState) => {
          // console.log("setCheckedItems", filteredCheckedItems, prevState);
          return prevState.filter(
            (item) => !filteredCheckedItems.includes(item)
          );
        });
      });
    }
  };
  return (
    <Box
      sx={{
        height: "240px",
        width: "300px",
        borderRadius: "10px",
        backgroundColor:
          user?.mode === "lite"
            ? backGroundColorCode("lite")
            : backGroundColorCode("dark"),
        boxShadow:
          user?.mode === "lite"
            ? "0px 0px 3px 1px #898b92"
            : "0px 0px 3px 1px black",
        padding: "10px",
        margin: "10px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "5px",
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            color:
              user?.mode === "lite"
                ? foreColorCode("lite")
                : foreColorCode("dark"),
          }}
        >
          {`製作課`}
        </Typography>
        <Typography
          sx={{
            fontSize: "16px",
            color:
              user?.mode === "lite"
                ? foreColorCode("lite")
                : foreColorCode("dark"),
            marginRight: "10px",
          }}
        >
          {departmentName !== "FLUCTUATION" ? `${departmentName}` : "CASE"}
        </Typography>
        <FormControlLabel
          sx={{
            color:
              parentChecked || indeterminate
                ? foreColorCodeLite(user?.mode ?? "dark")
                : foreColorCode(user?.mode ?? "dark"),
            "&.Mui-selected": {
              backgroundColor: backGroundColorCode(user?.mode ?? "dark"), // 選択時の背景色を変更
              color: foreColorCodeLite(user?.mode ?? "dark"), // 選択時の文字色を変更
            },
            "& .MuiFormControlLabel-label.Mui-disabled": {
              color: foreColorCodeDisabled(user?.mode ?? "dark"), // disabled時の色を設定
            },
            // ホバー状態のスタイルも定義できます
            "&:hover": {
              backgroundColor: backGroundColorCode(user?.mode ?? "dark"), // ホバー時の背景色を変更
              color: foreColorCodeLite(user?.mode ?? "dark"), // ホバー時の文字色を変更
            },

            // 選択されていてさらにホバーされた状態のスタイル
            "&.Mui-selected:hover": {
              backgroundColor: backGroundColorCode(user?.mode ?? "dark"), // 選択 + ホバー時の背景色
              color: foreColorCodeLite(user?.mode ?? "dark"), // 選択 + ホバー時の文字色
            },
          }}
          control={
            <Checkbox
              disabled={isDisabled}
              checked={parentChecked}
              indeterminate={indeterminate}
              onChange={handleParentChange}
              sx={{
                "& .MuiSvgIcon-root": isDisabled
                  ? foreColorDisabled(user?.mode ?? "dark")
                  : foreColor(user?.mode ?? "dark"),
                "&.Mui-checked": foreColor(user?.mode ?? "dark"),
                height: "38px",
              }}
            />
          }
          label={
            <Typography sx={{ fontSize: "16px", fontWeight: "bold" }}>
              すべて
            </Typography>
          }
        />
      </Box>
      <Divider
        textAlign="left"
        sx={dividerStyle(
          user?.mode === "lite" ? foreColorCode("lite") : foreColorCode("dark")
        )}
        variant="fullWidth"
      ></Divider>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          height: "180px",
          overflowY: "auto",
        }}
      >
        {productItems.map((item) => (
          <FormControlLabel
            key={item.id}
            sx={{
              color: checkedItems.includes(item.id)
                ? foreColorCodeLite(user?.mode ?? "dark")
                : "#a1a1a1",
              "&.Mui-selected": {
                backgroundColor: backGroundColorCode(user?.mode ?? "dark"), // 選択時の背景色を変更
                color: foreColorCodeLite(user?.mode ?? "dark"), // 選択時の文字色を変更
              },
              "& .MuiFormControlLabel-label.Mui-disabled": {
                color: foreColorCodeDisabled(user?.mode ?? "dark"), // disabled時の色を設定
              },

              // ホバー状態のスタイルも定義できます
              "&:hover": {
                backgroundColor: backGroundColorCode(user?.mode ?? "dark"), // ホバー時の背景色を変更
                color: foreColorCodeLite(user?.mode ?? "dark"), // ホバー時の文字色を変更
              },
              // 選択されていてさらにホバーされた状態のスタイル
              "&.Mui-selected:hover": {
                backgroundColor: backGroundColorCode(user?.mode ?? "dark"), // 選択 + ホバー時の背景色
                color: foreColorCodeLite(user?.mode ?? "dark"), // 選択 + ホバー時の文字色
              },
            }}
            control={
              <Checkbox
                disabled={isDisabled}
                checked={checkedItems.includes(item.id)}
                onChange={() => handleChildChange(item.id)}
                sx={{
                  "& .MuiSvgIcon-root": isDisabled
                    ? foreColorDisabled(user?.mode ?? "dark")
                    : foreColor(user?.mode ?? "dark"),
                  "&.Mui-checked": foreColor(user?.mode ?? "dark"),
                  height: "38px",
                }}
              />
            }
            label={
              <Typography
                sx={{ fontSize: "14px" }}
              >{`${item.id} ${item.name}`}</Typography>
            }
          />
        ))}
      </Box>
    </Box>
  );
};

export default ProductionDepartment;
const dividerStyle = (color) => {
  let styles = {
    borderColor: `${color}`, // 線の色をテーマのプライマリーカラーに設定
    fontSize: "18px",
    marginBottom: "0px",
    // Dividerにテキストがある場合、テキストのスタイルもここで定義できます
    "&::before, &::after": {
      // Dividerの線のスタイルをカスタマイズ
      borderTopColor: `${color}`, // これにより、線の色が変わります
    },
    color: `${color}`, // テキストの色を変更
    "@media (max-width: 600px)": {
      fontSize: "14px", // フォントサイズを14pxに設定
    },
  };
  return styles;
};
